import type { PageThemeDefinition } from "../types";

export const lightTheme: PageThemeDefinition = {
  id: "light",
  labelKey: "robot.setting.page_theme.light",
  preview: {
    background: "#ffffff",
    cardBg: "#f5f5f5",
    text: "#333333",
  },
  tokens: {
    background: "#ffffff",
    cardBg: "#f5f5f5",
    text: "#333333",
    textSecondary: "#9aa3b2",
    border: "#ececec",
    headerBg: "#ffffff",
    inputBg: "#ffffff",
    messageBg: "#f0f0f0",
    senderBg: "#f5f5f5",
    statusOnline: "#52c41a",
    statusEnding: "#ff4d4f",
    starActive: "#faad14",
    starInactive: "#d9d9d9",
    shadow: "rgba(0, 0, 0, 0.08)",
    hoverBg: "#e6f7ff",
    accent: "#1677ff",
    appearance: "light",
    chatMessageText: "#333333",
    chatAgentBubbleBg: "#F2F4F7",
    chatAgentBubbleBorder: "#DDE1E6",
    chatUserGradientStart: "#4096ff",
    chatUserGradientEnd: "#1677ff",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#ffffff",
    chatInputText: "#333333",
    chatInputPlaceholder: "#9aa3b2",
    chatMediaBg: "#f0f0f0",
    chatIconColor: "#333333",
    chatLinkColor: "#1677ff",
  },
};
